import {
  getEstadoVencimientoClass,
  getEstadoVencimientoLabel,
} from '../../utils/partidasFormatters';

export default function PartidaEstadoBadge({ estado }) {
  return (
    <span className={`partidas-status-badge ${getEstadoVencimientoClass(estado)}`}>
      {getEstadoVencimientoLabel(estado)}
    </span>
  );
}
